import type { OptimizationBlockState, ResumeOptimizationRun } from '../../../lib/optimization/types'
import { extractSkillGapSummary } from '../../../lib/optimization/skillGapRecommendations'
import OptimizationSkillsGapPanel from './OptimizationSkillsGapPanel'

interface OptimizationSkillsGapRecommendationsProps {
  block?: OptimizationBlockState
  run?: ResumeOptimizationRun | null
}

export default function OptimizationSkillsGapRecommendations({
  block,
  run,
}: OptimizationSkillsGapRecommendationsProps) {
  const summary = extractSkillGapSummary(run, block)
  return <OptimizationSkillsGapPanel summary={summary} />
}
